import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import Approved from "../../assets/images/approved.png";
import Pending from "../../assets/images/pending 2.png";
import Add from "../../assets/images/UpcomingEvent/add 1.png";
import Live from "../../assets/images/instagram-live 1.png";
import axios from "axios";

const PromoAdminNav = () => {
  const [live, setLive] = useState("");
  const [approved, setApproved] = useState("");
  const [pending, setPending] = useState("");
  const location = useLocation();
  //Fetch Approved LiveChat
  useEffect(() => {
    axios.get(`/api/admin/promoVideoCount`).then((res) => {
      if (res.status === 200) {
        setLive(res.data.liveTotal);
        setApproved(res.data.approveTotal);
        setPending(res.data.pendingTotal);
      }
    });
  }, []);

  return (
    <>
      <div className="mb-3 row">
        {location.pathname == "/superstar-admin/live/promoVideo" ||
          location.pathname == "/superstar-admin/promo-videos" ? (
          <>
            <div
              title="Live Now"
              className="col-md-3 align-items-center justify-content-center "
            >
              <div className="card livechat-card nav-card-border">
                <div className="card-body  align-items-center">
                  <center>
                    <tr>
                      <td className="livechat-card-td">
                        <img src={Live} className="img-top" alt="..." />
                      </td>
                      <td className="livechat-card-td">
                        <small className="p-3 fw-bold rounded-1 text-warning textFontResult">
                          {live}
                        </small>
                      </td>
                    </tr>
                  </center>
                </div>
                <Link
                  to="/superstar-admin/live/promoVideo"
                  className="card-footer livechat-card-footer"
                >
                  <button
                    className="livechat-card-footer"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Live Now
                  </button>
                </Link>
              </div>
            </div>
            <br />
          </>
        ) : (
          <></>
        )}

        {location.pathname == "/superstar-admin/approved/promoVideo" ||
          location.pathname == "/superstar-admin/promo-videos" ? (
          <>
            <div
              title="Live Now"
              className="col-md-3 align-items-center justify-content-center "
            >
              <div className="card livechat-card nav-card-border">
                <div className="card-body  align-items-center">
                  <center>
                    <tr>
                      <td className="livechat-card-td">
                        <img src={Approved} className="img-top" alt="..." />
                      </td>
                      <td className="livechat-card-td">
                        <small className="p-3 fw-bold rounded-1 text-warning textFontResult">
                          {approved}
                        </small>
                      </td>
                    </tr>
                  </center>
                </div>
                <Link
                  to="/superstar-admin/approved/promoVideo"
                  className="card-footer livechat-card-footer"
                >
                  <button
                    className="livechat-card-footer"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Approved
                  </button>
                </Link>
              </div>
            </div>
            <br />
          </>
        ) : (
          <></>
        )}

        {location.pathname == "/superstar-admin/pending/promoVideo" ||
          location.pathname == "/superstar-admin/promo-videos" ? (
          <>
            <div
              title="Live Now"
              className="col-md-3 align-items-center justify-content-center "
            >
              <div className="card livechat-card nav-card-border">
                <div className="card-body  align-items-center">
                  <center>
                    <tr>
                      <td className="livechat-card-td">
                        <img src={Pending} className="img-top" alt="..." />
                      </td>
                      <td className="livechat-card-td">
                        <small className="p-3 fw-bold rounded-1 text-warning textFontResult">
                          {pending}
                        </small>
                      </td>
                    </tr>
                  </center>
                </div>
                <Link
                  to="/superstar-admin/pending/promoVideo"
                  className="card-footer livechat-card-footer"
                >
                  <button
                    className="livechat-card-footer"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Pending
                  </button>
                </Link>
              </div>
            </div>
            <br />
          </>
        ) : (
          <></>
        )}
        {location.pathname == "/superstar-admin/upload/promoVideo" ||
          location.pathname == "/superstar-admin/promo-videos" ? (
          <>
            <div
              title="Live Now"
              className="col-md-3 align-items-center justify-content-center "
            >
              <div className="card livechat-card nav-card-border">
                <div className="card-body  align-items-center">
                  <center>
                    <tr>
                      <td className="livechat-card-td">
                        <img src={Add} className="img-top" alt="..." />
                      </td>
                      <td className="livechat-card-td">
                        <small className="p-3 fw-bold rounded-1 text-warning textFontResult"></small>
                      </td>
                    </tr>
                  </center>
                </div>
                <Link
                  to="/superstar-admin/upload/promoVideo"
                  className="livechat-card-footer"
                >
                  <button
                    className="card-footer livechat-card-footer"
                    data-bs-toggle="collapse"
                    data-bs-target="#collapseOne"
                    aria-expanded="true"
                    aria-controls="collapseOne"
                  >
                    Upload Promo Video
                  </button>
                </Link>
              </div>
            </div>
          </>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default PromoAdminNav;
